import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { ButtonBase } from '@material-ui/core';
import { showError } from '../../../../../Helper';
import excellogo from '../../../../../assets/images/defaults/microsoft_office_excel_logo.png';
import { HubspotComponentView } from '../../HubspotComponents/HubspotComponentView';
import { SelectComponet } from '../../../../../Components';

export const SearchAndAddComponent = ({
  parentTranslationPath,
  translationPath,
  state,
  schema,
  ifHaveAnyErrors,
  searchHandler,
  setIsOpenSaveDialog,
  exportDataToFormats,
  searchResponse,
  createHubSpotJson,
}) => {
  const { t } = useTranslation([parentTranslationPath, 'Shared']);
  const [isOpenHubSpot, setIsOpenHubSpot] = useState(false);
  const [SlectValue, setSlectValue] = useState(false);
  const [pullToHubType, setpullToHubType] = useState(null);

  useEffect(() => {
    if (SlectValue === 'Hubspot' || SlectValue === 'Convolo') {

      if (!searchResponse?.result?.length) {
        showError(
          t(
            `${translationPath}dont-have-data-to-pull-to-hub-spot-contacts-please-select-data-and-search-before-pulling`
          )
        );
        return;
      }

      if (SlectValue === 'Hubspot') {
        setIsOpenHubSpot(true);
        setpullToHubType('Hubspot');
      } else if (SlectValue === 'Convolo') {
        setIsOpenHubSpot(true);
        setpullToHubType('Convolo');
      }
    }
  }, [SlectValue]);


  useEffect(() => {
    if (!isOpenHubSpot) {
      setSlectValue(null)
      setpullToHubType(null);
    }
  }, [isOpenHubSpot]);



  return (
    <div className=''>
      <div className='save-wrapper d-inline-flex-center'>
        <div className='d-flex-center'>
          <SelectComponet
            idRef='agHubspotckedRef'
            data={[
              { id: 'Hubspot', value: 'Hubspot' },
              { id: 'Convolo', value: 'Convolo ' },
            ]}
            wrapperClasses='w-auto'
            value={SlectValue}
            onSelectChanged={(value) => setSlectValue(value)}
            valueInput='id'
            textInput='value'
            emptyItem={{
              value: null,
              text: 'Pull-contacts-to',
              isDisabled: false,
            }}
            parentTranslationPath={parentTranslationPath}
            themeClass='theme-default'
          />


        </div>
        <div className='excelPart'>
          {' '}
          <ButtonBase
            className='MuiButtonBase-root MuiButton-root MuiButton-text table-action-btn btns miw-0'
            tabIndex='0'
            type='button'
            id='export-ref'
            onClick={() => exportDataToFormats('xls', 'ReportView')}
          >
            <span className='MuiButton-label'>
              <div className=''>
                <img src={excellogo} alt='arrowImage' className='excelImage1' />
              </div>
              <span className='px-1 info fw-normal'>
                {t(`${translationPath}export-excel`)}
              </span>
            </span>
            <span className='MuiTouchRipple-root' />
          </ButtonBase>
        </div>
      </div>
      {isOpenHubSpot && (
        <HubspotComponentView
          parentTranslationPath={parentTranslationPath}
          translationPath={translationPath}
          onClose={() => setIsOpenHubSpot(false)}
          isOpen={isOpenHubSpot}
          pullToHubType={pullToHubType}
          state={state}
          createHubSpotJson={createHubSpotJson}
          totalCount={
            searchResponse?.totalCount ||
            (searchResponse?.result &&
              searchResponse?.result?.length > 0 &&
              searchResponse?.result[0] &&
              searchResponse?.result[0].TotalCount) ||
            1
          }
        />
      )}
    </div>
  );
};

SearchAndAddComponent.propTypes = {
  parentTranslationPath: PropTypes.string.isRequired,
  translationPath: PropTypes.string.isRequired,
  state: PropTypes.instanceOf(Object).isRequired,
  schema: PropTypes.instanceOf(Object).isRequired,
  searchHandler: PropTypes.func.isRequired,
  setIsOpenSaveDialog: PropTypes.func.isRequired,
  ifHaveAnyErrors: PropTypes.bool.isRequired,
  exportDataToFormats: PropTypes.func.isRequired,
};
